import { Component, Inject, ViewChild } from '@angular/core';
import { VentanaFlotante } from '../../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComentarioComponent } from '../detalle-peticion/comentario/comentario.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { UsuarioService } from '../../services/user.service';
import { GestionPeticionService } from '../../services/bd/GestionPeticion/gestion-peticion.service';
import { DetallePetcicionAlp } from './DetallePetcicionAlp';
import {AlertArgumentarioComponent} from "../../../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {DetallePetcicion} from "../detalle-peticion/DetallePetcicion";
import {ListadoComentariosComponent} from "../../listado-comentarios/listado-comentarios.component";
@Component({
  selector: 'ral-detalle-peticion-alp',
  templateUrl: './detalle-peticion-alp.component.html',
  styleUrls: ['./detalle-peticion-alp.component.scss']
})
export class DetallePeticionAlpComponent extends VentanaFlotante
{
  comentarioColumns :string[] = ["Lin.","Fecha/Hora","Comentário","Usuario"];
  comentarios:ComentarioContact[] = [];
  comentarioSource: MatTableDataSource<ComentarioContact> = new MatTableDataSource(this.comentarios);
  usuario:string = "";
  infoPeticion : DetallePetcicionAlp = new DetallePetcicionAlp();
  mostrarCarga:boolean = true;
  estadoAnterior: string = "";
  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private dialogComentario : MatDialog, // Additional parameter to override in the constructor
    private userService:UsuarioService,
    private peticionService:GestionPeticionService,
    private dialog: MatDialog
  )
  {super(dialogRef, data);}

  ngOnInit() {
      this.peticionService.getDetalleAlp(this.data.token, this.data.peticion.toString()).then(res => {
        this.infoPeticion.convertirDetalle(res);
      }).finally(() => {
        this.usuario = this.userService.getNombreCuenta();
          this.peticionService.getLineasComentario(this.data.token, this.data.peticion, this.data.padre.controlGestion)
            .then(res => {
              this.comentarios = res;
              this.comentarioSource.data = this.comentarios;
              this.estadoAnterior = this.infoPeticion.estado;
            })
            .catch(err => {
              this.data.padre.formInic.mostrarArgumentario("Error", ["Ha habido un error al insertar el comentario"], false, true, true);
              this.mostrarCarga = false;
            })
            .finally(() => {
              this.mostrarCarga = false;
            })
      });

  }
  //se abre el
  agregarComentario()
  {
    const dialogRef = this.dialogComentario.open(ComentarioComponent,
      {data:
        {
          token:this.data.token,
          idPeticion:this.data.peticion,
          tipo: this.data.padre.controlGestion,
          numNuevaLinea : this.comentarios.length+1//EL CONTROLLER YA SE ENCARGA DE CALCULAR EL NUMERO DE LINEA
        }
      }
    );

    dialogRef.afterClosed()
    .subscribe(result =>
    {
      //SI el result es valido
      if(result != undefined && result != null && result != "")
      {
        const hoyAhora = this.getHoy();
        //asignamos el taller seleccionado del buscador al form principal
        this.agregarOrdenado(result);
      }
    });
  }

  abrirGrande(){
    const listado = this.dialog.open(ListadoComentariosComponent, {
      data: { datos:this.comentarios, columns:['linea', 'created', 'obser', 'usuario'] },
    });
  }
  //vuelca los datos del detalle a la ventana principal
  generarHoja()
  {

    this.infoPeticion.convertiHoja(this.data.padre.formInic, this.data.padre.busqueda.toString());
    this.dialogRef.close(true);
  }
  //retorna la fecha y hora actuales en formato string
  private getHoy():string
  {
    const currentDate = new Date();
    return currentDate.toLocaleString('es-ES',
    {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  //agrega el comentario nuevo y ordena el listado
  //despues, actualiza el source
  private agregarOrdenado(comentario:ComentarioContact)
  {
    this.comentarios.push(comentario);
    // Ordenamos el array por linea (Descendiente)
    this.comentarios = this.ordenarComentariosPorLinea(this.comentarios);
    this.comentarioSource.data=this.comentarios;
  }

  private ordenarComentariosPorLinea(comentarios: ComentarioContact[]): ComentarioContact[]
  {
    return comentarios.sort((a, b) => b.linea - a.linea);
  }

  cambiarEstado(nuevoEstado: string){
    const dialogRef = this.data.padre.formInic.dialog.open(AlertArgumentarioComponent,
      {
        data: {
          titulo: "Atención",
          lineas: ["Realmente desea cambiar el estado de la petición?"],
          mostrarBtnAceptar: true
        }
        ,disableClose:true
      });
    dialogRef.afterClosed().subscribe((result: boolean)  => {
      if (result){
        this.estadoAnterior = nuevoEstado;
        let paramArr = [];
        let param= {
          "id": this.data.peticion,
          "estado_contact": this.infoPeticion.convertirEstadoUpdate(nuevoEstado),
          "usuario": this.userService.getNombreCuenta()
        }
        paramArr.push(param);

        this.peticionService.UpdateEstadoWeb(this.data.token, this.data.padre.controlGestion, paramArr, this.data.padre.tipoGestion).then(
          (res: any) => {
            if(res){
              this.data.padre.formInic.mostrarArgumentario("OK",["Se ha cambiado el estado de la petición.!"],true);
              this.data.padre.buscar();
            }
          },
          (err:any) => {
            this.data.padre.formInic.mostrarArgumentario("Error", [err.message], true, true, true);
          }
        )
      }else{
        this.infoPeticion.estado= this.estadoAnterior;
      }
    });
  }

}

export interface ComentarioContact
{
  linea:number, created:string,obser:string,usuario:string;
}